import { Plug } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { SSO_PERMISSIONS } from '@/lib/permissions'
import {
  authLoginRoute,
  authCallbackRoute,
  authResetRoute,
  signupRoute,
  entityFederationRoute,
  oauthConsentRoute,
  connectedAppsRoute,
} from './routes'

export const identityModule = defineModule({
  routes: [
    authLoginRoute,
    authCallbackRoute,
    authResetRoute,
    signupRoute,
    entityFederationRoute,
    oauthConsentRoute,
    connectedAppsRoute,
  ],
  navigation: {
    access: [
      {
        to: '/$entityId/federation',
        label: 'Federation',
        icon: Plug,
        permission: SSO_PERMISSIONS.manage,
        section: 'configure',
        order: 20,
      },
    ],
  },
})
